<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DashboardLayout from '@/layouts/DashboardLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'

const route = useRoute()

const layout = computed(() => {
  return route.meta.layout as string | undefined
})
</script>

<template>
  <DashboardLayout v-if="layout === 'dashboard'">
    <RouterView />
  </DashboardLayout>
  <AuthLayout v-else-if="layout === 'auth'">
    <RouterView />
  </AuthLayout>
  <RouterView v-else />
</template>
